import { EnumCountryCode } from '../models/enumCountryCode';

export class LocalStorageUtils {
  constructor() {}
  public getUserToken(): string | null {
    const key = localStorage.getItem('TokenKey') as any;

    if (key == null) {
      return '';
    }

    const token = localStorage.getItem(key.toString()) as any;
    return JSON.parse(token).secret;
  }

  getAccessToken(): string {
    const key = localStorage.getItem('TokenAccess') as any;

    if (key == null) {
      return '';
    }

    const token = localStorage.getItem(key.toString()) as any;
    return JSON.parse(token).secret;
  }

  public getCurrentLanguage(): string {
    const language = localStorage.getItem('language') as any;
    if (language !== null && language !== '' && language !== undefined) {
      switch (language) {
        case 'br': {
          return 'pt-BR';
        }
        case 'us': {
          return 'en-US';
        }
        case 'es-AR': {
          return 'es-AR';
        }
        case 'es-PE': {
          return 'es-PE';
        }
        case 'es-CL': {
          return 'es-CL';
        }
        default: {
          return 'pt-BR';
        }
      }
    } else {
      return 'pt-BR';
    }
  }

  public getCurrentCountryCode(): string {
    const countryCode = localStorage.getItem('countryCode') as any;
    if (
      countryCode !== null &&
      countryCode !== undefined &&
      countryCode !== '' &&
      EnumCountryCode[countryCode as keyof typeof EnumCountryCode] !== undefined
    ) {
      return countryCode;
    } else {
      return 'NOT_DEFINED';
    }
  }

  public GetEnumCountryCode() {
    return EnumCountryCode[this.getCurrentCountryCode() as keyof typeof EnumCountryCode];
  }
}
